import { render, staticRenderFns } from "./CompanyKeyEmployees.vue?vue&type=template&id=e01090c4"
import script from "./CompanyKeyEmployees.vue?vue&type=script&lang=js"
export * from "./CompanyKeyEmployees.vue?vue&type=script&lang=js"
import style0 from "./CompanyKeyEmployees.vue?vue&type=style&index=0&id=e01090c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports